import { connect } from 'react-redux';
import GenericLoader, { buildLoader } from '../util/GenericLoader';
import {
  fetchExecutions,
  fetchCodes,
  fetchSchedules,
  fetchLogs,
  fetchResults,
} from '../../redux/actions/analytics-actions';

export const ExecutionsLoader = buildLoader(fetchExecutions);

export const CodesLoader = buildLoader(fetchCodes);

export const SchedulesLoader = buildLoader(fetchSchedules);

export const ResultsLoader = connect(null, (dispatch, { execId }) => ({
  fetchFunction: () => execId && dispatch(fetchResults(execId)),
}))(GenericLoader);

export const LogsLoader = connect(null, (dispatch, { execId }) => ({
  fetchFunction: () => execId && dispatch(fetchLogs(execId)),
}))(GenericLoader);
